export default __webpack_public_path__ + "static/media/arrow-left.350666e0.svg";